module.exports = __webpack_public_path__ + "assets/img/partner6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner6.jpeg
// module id = 1971
// module chunks = 0